import styled from 'styled-components';
import { flexbox, alignItems } from '../../../../../../styles/helpers/flexbox';

const Container = styled.div`
  ${flexbox()};
  ${alignItems('center')};
  font-size: 12px;
`;

export default Container;



// WEBPACK FOOTER //
// ./components/student-list/student-modal/student-result/doughnut-chart/doughnut-legend/doughnut-legend.styled.js